import React from "react";

export function PriceLabel(props) {
  const { min, max } = props;
  const idrFormatter = new Intl.NumberFormat("id", {
    style: "currency",
    currency: "IDR",
  });
  let prices = [];
  if (!!min) prices.push(min);
  if (!!max) prices.push(max);
  prices = prices.map((price) => idrFormatter.format(price));

  let priceString = prices.join(" - ");
  return <div className={props.className}>{`${props.prefix || ''}${priceString}${props.suffix || ''}`}</div>;
}
